import React, { FunctionComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MenuItem from "@mui/material/MenuItem";
import { Icon } from "@hxnova/icons";

import signOutUser from "../../../actions/sign_in_page/sign_out_user";
import { useFlags } from "../../../services/utilities/launch_darkly_helper";

export type Props = ReturnType<typeof mapDispatchToProps>;

export const NavBarKebabItemLogout: FunctionComponent<Props> = (props) => {
  const { signOutUser } = props;
  const { userProfileFeatureEnabled } = useFlags();

  return <MenuItem className="NavBarKebabItemLogout NavBarKebabMenu-menuItem" onClick={() => signOutUser()}>
    {userProfileFeatureEnabled && <Icon name="logout" family="material" className="NavBarKebabMenu-menuIcon"/>}
    Logout
  </MenuItem>;
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  signOutUser,
}, dispatch);

export default connect(null, mapDispatchToProps)(NavBarKebabItemLogout);
